import TextWinds from '../../../components/common/TextWinds';

const ErrorInput = ({ text }: { text: string }) => (
  <TextWinds type="caption1" children={text} className="text-red-500" />
);

export default ErrorInput;
